module.exports = "<app-permisos></app-permisos>"